import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ms-dpr-passport-layout',
  templateUrl: './passport-layout.component.html',
  styleUrls: ['./passport-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PassportLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
